/*!jslint
  this
*/
jQuery(function($) {
  "use strict";
   	
    $('.banner-slider').slick({
      dots: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 5000
    });
    $('.work-cl').slick({
      dots: false,
      infinite: true,
      speed: 300,
      arrows: false,
      slidesToShow: 2,
      slidesToScroll: 1
    });
    $(document).on("click", ".main-navigation a", function(e) {
      if($('body').hasClass('home')){
        var href = $(this).attr("href");
        var offsetTop = href === "#" ? 0 : $(href).offset().top;
        var HdTop = $(".site-header").outerHeight();
        $("html, body").stop().animate({
            scrollTop: offsetTop - HdTop
        }, 500);
        e.preventDefault();
      }else{
        var href = $(this).attr("href");
        window.location.href = alabbartechdata.siteurl+href;
      }
    });
    $(window).on('scroll', function(e){
      if($(this).scrollTop() >= 130){
        $('.site-header').addClass('sticky-header');
      }else{
        $('.site-header').removeClass('sticky-header');
      }
    });
});
